import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { getClass } from '../../../utils/component-helpers';
import Icon from '../icon';
import './search.scss';

const SearchBar = props => {
  const { onChange, placeholder, styleType } = props;

  const [isActive, setActive] = useState(false);
  const [queryString, setQueryString] = useState('');
  const barClasses = getClass('input-search-bar', styleType, {
    active: isActive,
  });

  const clearSearch = e => {
    e.stopPropagation();
    setQueryString('');
    onChange('');
  };

  const onTextChange = e => {
    const newQueryString = e.target.value;
    setQueryString(newQueryString);
    onChange(newQueryString);
  };

  return (
    <div className={barClasses}>
      <div className="search-icon">
        <Icon iconName="search" size={20} />
      </div>
      <input
        className="search-input"
        type="text"
        value={queryString}
        placeholder={placeholder}
        onChange={onTextChange}
        onFocus={() => setActive(true)}
        onBlur={() => setActive(false)}
      />
      {queryString && (
        <div className="x-icon" onClick={clearSearch}>
          <Icon iconName="x" size={10} />
        </div>
      )}
    </div>
  );
};

SearchBar.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  styleType: PropTypes.string,
};

SearchBar.defaultProps = {
  placeholder: 'Search...',
  onChange: () => {},
  styleType: 'default',
};

export default SearchBar;
